import FetchClient, { type ApiResponse } from "./FetchClient";

export interface ProxyUsageWindow {
  proxyBytes: number;
  proxyMB: number;
  proxyGB: number;
  startedAtMs: number;
  endedAtMs: number;
  pages: number;
  itemsSeen: number;
  requestCount: number;
  estDateYMD?: string;
}

export interface ProxyUsageRow {
  retailer: string;
  storeId: string;
  beforeNoon?: ProxyUsageWindow;
  afternoon?: ProxyUsageWindow;
  lastUpdated?: number;
}

export interface ProxyUsageTotals {
  stores: number;
  beforeNoonGB: number;
  afternoonGB: number;
  totalGB: number;
  beforeNoonPages: number;
  afternoonPages: number;
  totalPages: number;
  beforeNoonItems: number;
  afternoonItems: number;
  totalItems: number;
  beforeNoonRequests: number;
  afternoonRequests: number;
  totalRequests: number;
}

export interface ProxyUsageResponse {
  rows: ProxyUsageRow[];
  totals: ProxyUsageTotals;
}

export async function getProxyUsage(): Promise<ProxyUsageResponse> {
  const response = await FetchClient.get<ApiResponse<ProxyUsageResponse>>("/admin/proxy-usage");
  return response.data ?? { rows: [], totals: emptyTotals() };
}

function emptyTotals(): ProxyUsageTotals {
  return {
    stores: 0,
    beforeNoonGB: 0,
    afternoonGB: 0,
    totalGB: 0,
    beforeNoonPages: 0,
    afternoonPages: 0,
    totalPages: 0,
    beforeNoonItems: 0,
    afternoonItems: 0,
    totalItems: 0,
    beforeNoonRequests: 0,
    afternoonRequests: 0,
    totalRequests: 0,
  };
}
